module.exports = __webpack_public_path__ + "img/wq_thumb.7873504c.gif";